<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400">
    <v-card class="px-6 pb-10">
      <v-card-title>
        <span class="d-flex mx-auto">
          <slot name="title">Select Exercise Type</slot>
        </span>
      </v-card-title>
      <v-hover #default="{ hover }" v-for="item in items" :key="item.component">
        <v-btn v-text="item.text" block :dark="hover" @click="$emit(item.event, item.component)" />
      </v-hover>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false,
    },
    items: Array,
  },
};
</script>
